import { Component } from '@angular/core';
import { UrlService } from '../services/url.service';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss'],
  standalone: false
})
export class PrivacyComponent {

  constructor(public urlService: UrlService) {}

  getCurrentDate(): string {
    return new Date().toLocaleDateString();
  }

  /**
   * Get the base URL for generating component URLs
   */
  getBaseUrl(): string {
    return this.urlService.getBaseUrl();
  }

  /**
   * Get the Privacy Policy URL (current page)
   */
  getPrivacyUrl(): string {
    return this.urlService.getPrivacyUrl();
  }

  /**
   * Get the Terms of Service URL
   */
  getTermsUrl(): string {
    return this.urlService.getTermsUrl();
  }

}
